import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router'
import NewFormWizard from '../../../../components/formWizard/NewFormWizard'
import Layout from '../../../../components/layouts/Layout'
import { eventBrustGifs } from '../slice/createEventSlice'
import NewFormWizardChild from '../../../../components/formWizard/NewFormWziardChild'
import BrustGifModal from '../../components/Modal/BrustGifModal'
import { IoTrashSharp } from 'react-icons/io5'
import { IoIosSettings } from 'react-icons/io'
import http, { URL_S3 } from '../../../../config/BaseUrl'
import { ImEqualizer2 } from 'react-icons/im'
import { LoadingSpinner } from '../../../../components/Loader/Loader'
import BrustGifSettingsModal from '../../components/Modal/BrustGifSettingsModal'

function BrustGif() {
    
  const history = useHistory()
  const dispatch = useDispatch()
  // const eventId = history.location.state
  const { event_option, brust_gifs, eventId } = useSelector(state => state.createEvent)
  const [selectedBrustGif, setSelectedBrustGif] = useState([])
  const [loading, setLoading] = useState(false)
  const [draftLoading, setDraftLoading] = useState(false)
  const [openModal, setOpenModal] = useState(false)
  const [brustGifId, setBrustGifId] = useState(null)
  const [brustGifTemplateErr, setBrustGifTemplateErr] = useState(false)



    const handelTemplate = (e) => {
        e.preventDefault();
        if(selectedBrustGif.length > 0){
            dispatch(eventBrustGifs(selectedBrustGif))
            setLoading(true)
            http.post("event-brust-gif", { brust_gif: selectedBrustGif, eventId }).then(res => {
                setLoading(true)
                if (res.data.brust_gif === 'success') {
                    if (event_option) {
                        if (event_option.email === true) { history.push('/event/email', eventId) }
                        else if (event_option.text_messaging    === true) { history.push('/event/sms', eventId) }
                        else if (event_option.digital_props     === true) { history.push('/event/digital-prop', eventId) }
                        else if (event_option.water_mark        === true) { history.push('/event/custom-branding', eventId) }
                        else if (event_option.microsite         === true) { history.push('/event/microsite', eventId) }
                        else if (event_option.frame_option      === true) { history.push('/event/frame', eventId) }
                        else if (event_option.incentive_offer   === true) { history.push('/event/incentive-offer', eventId) }
                        else if (event_option.filters           === true) { history.push('/event/filter', eventId) }
                        else if (event_option.form_builder === true) { history.push('/event/form-builder', eventId) }
                        else { history.push('/event/summary', eventId) }
                    }
                }
                setLoading(false)
            }).catch((err) => console.log("err", err.response.data))
        }else{
            setBrustGifTemplateErr(true)
        }
    }

    useEffect(() => {
       
       if(brust_gifs){
        if (brust_gifs.length > 0) {
            setSelectedBrustGif(brust_gifs)
        }
       }
        
    }, [brust_gifs])

    const setBrustGifByProps = (data) => {
        setSelectedBrustGif(data)
        setBrustGifTemplateErr(false)
    }

    const removeProps = (id) => {
        let copyProps = [...selectedBrustGif]
        copyProps.splice(id, 1)
        setSelectedBrustGif(copyProps)

    }

    const saveAsDraft = () => {
        if(selectedBrustGif.length > 0){

            dispatch(eventBrustGifs(JSON.stringify(selectedBrustGif)))
            setDraftLoading(true)
            http.post("event-brust-gif", { brust_gif: selectedBrustGif, eventId }).then(res => {
                setDraftLoading(false)
            }).catch(err => setDraftLoading(false))

        }else{
            setBrustGifTemplateErr(true)
        }
    }

    const submitTrigger = (data) => {
        let copyData = [...selectedBrustGif]
        let indexItem = copyData.findIndex(item => item.id == data.brustGifId)
        delete copyData[indexItem].settings
        if (indexItem >= 0) {
            copyData[indexItem]['settings'] = data
        }
        setSelectedBrustGif(copyData)

    }

    const settingsOpen = (item) => {
        setBrustGifId(item)
        setOpenModal(true)
    }
    
    const BackToPreviousPage = (e) => {
        e.preventDefault()
        if (event_option.gif               === true) { history.push('/event/gif') }
        else if (event_option.social_media === true) { history.push('/event/social') }
        else { history.push('/event/options') }
    }

  return (
      <Layout>
          <NewFormWizard />
          <NewFormWizardChild />

          <form onSubmit={handelTemplate}>
              <section className="mt-4">
                  <div className="row justify-content-center">
                      <div className="text-center col-12 col-md-10">
                        <div className="card">
                          <div className="card-body">
                            <div className="">
                              <p className="mb-0 display-4 text-primary event-form-title">Speed Burst Chooser</p>
                            </div>
                          </div>
                        </div>

                      </div>
                      <div className="col-md-10">
                          <div className="p-4 bg-white border d-flex flex-column radius-10 ">
                              <div className="d-flex align-items-center justify-content-between">
                                  <div className="d-flex align-items-center">
                                      <ImEqualizer2 size={30} />
                                      <p className="mb-0 ml-2 font-size-16">Animation Library</p>
                                  </div>
                                  <div className="float-right">
                                      <button type="button" className="mr-3 btn btn-outline-primary" data-toggle="modal" data-target="#event-frame-modal">Select Speed Burst</button>
                                      <BrustGifModal 
                                        setData={setBrustGifByProps} 
                                        selectedBrustGif={selectedBrustGif} 
                                      />
                                  </div>
                              </div>
                              {brustGifTemplateErr &&
                                            <p className={`pt-2 mb-0 text-danger font-weight-bold text-right fade ${brustGifTemplateErr ? 'show' : 'hide'}`}>Choose any animation </p>
                                        }
                              <div className="prop__area">
                                  <div className="flex-wrap props-list d-flex">
                                      {
                                          selectedBrustGif.length > 0 ?
                                              selectedBrustGif.map((propItem, index) => (
                                                  <div className="prop__item" key={`digital-props-index-${index}`}>
                                                      <img src={`${URL_S3}image/burstGif/preview_image/${propItem.image}`} className="img-fluid" alt="props-data" />
                                                      <div className="remove-props d-flex justify-content-around align-items-center">
                                                        <span className="font-small" onClick={removeProps.bind(this, index)}>
                                                          <IoTrashSharp />
                                                        </span>
                                                        <span className="font-small" onClick={settingsOpen.bind(this, propItem)}>
                                                          <IoIosSettings />
                                                        </span>
                                                      </div>
                                                  </div>
                                              ))

                                              :
                                              <div className="prop__no__item">
                                                  <h4>No Speed Burst Selected.</h4>
                                              </div>
                                      }

                                  </div>

                              </div>
                          </div>
                      </div>
                  </div>
                  <div className="my-5 row justify-content-center">
                      <div className="col-md-10">
                          <button type="button" onClick={BackToPreviousPage} className="float-left px-5 btn btn-outline-secondary radius-10">Back</button>
                          {loading ?
                              (<button className="float-right px-5 btn btn-primary radius-10" disabled>
                                  <LoadingSpinner color="text-white" className="spinner-grow-sm" />
                              </button>)
                              : <button type="submit" disabled={draftLoading} className="float-right px-5 btn btn-primary radius-10">Next</button>
                          }

                          {
                              loading ?
                                  (<button className="float-right px-3 mr-2 btn btn-secondary radius-10" disabled>
                                      <LoadingSpinner color="text-white" className="spinner-grow-sm" />
                                  </button>)
                                  :
                                  <button type="button" onClick={saveAsDraft} className="float-right px-3 mr-2 btn btn-secondary radius-10">Save as draft</button>
                          }
                      </div>
                  </div>

                  <BrustGifSettingsModal 
                    isOpen={openModal} 
                    closeModal={setOpenModal} 
                    brustGifId={brustGifId && brustGifId.id} 
                    submitTrigger={submitTrigger} 
                    selectedSettings={brustGifId && brustGifId.settings}
                    canSetCustomFrame={false}
                  />

              </section>
          </form>
      </Layout>
    )
}

export default BrustGif
